import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetMagnifyingGlass: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      >
        <path d="M11 19a8 8 0 100-16 8 8 0 000 16zm5.65-2.35L21 21" />
      </svg>
    </div>
  );
};

export default WidgetMagnifyingGlass;
